<script setup lang="ts">
import { Best, Correct, Inaccuracies, Wrong, Blunders } from '@/assets/icons/statistic'
import type { Move } from '@/types'
import { SuggestedActionQuality } from '@acepoker/api-core'

const { items } = defineProps<{ items: Move[] }>()

const total = items.reduce((acc, cur) => acc + cur.count, 0)
</script>

<template>
  <div class="flex w-full items-center bg-light-grey rounded p-1 gap-1">
    <div class="text-[15px] font-semibold text-text-helper px-2">{{ total }}</div>
    <template v-for="({ quality, count }, index) in items" :key="index">
      <div
        v-if="quality === SuggestedActionQuality.Best"
        class="flex flex-1 p-1 rounded bg-best max-w-[59px]"
      >
        <best />
        <div class="grow text-[15px] font-semibold">{{ count }}</div>
      </div>
      <div
        v-else-if="quality === SuggestedActionQuality.Correct"
        class="flex flex-1 p-1 rounded bg-correct max-w-[59px]"
      >
        <correct />
        <div class="grow text-[15px] font-semibold">{{ count }}</div>
      </div>
      <div
        v-else-if="quality === SuggestedActionQuality.Inaccuracy"
        class="flex flex-1 p-1 rounded bg-inaccuracy max-w-[59px]"
      >
        <inaccuracies />
        <div class="grow text-[15px] font-semibold">{{ count }}</div>
      </div>
      <div
        v-else-if="quality === SuggestedActionQuality.Wrong"
        class="flex flex-1 p-1 rounded bg-wrong max-w-[59px]"
      >
        <wrong />
        <div class="grow text-[15px] font-semibold">{{ count }}</div>
      </div>
      <div
        v-else-if="quality === SuggestedActionQuality.Blunder"
        class="flex flex-1 p-1 rounded bg-blunder max-w-[59px]"
      >
        <blunders />
        <div class="grow text-[15px] font-semibold">{{ count }}</div>
      </div>
    </template>
  </div>
</template>
